// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1 {
  margin: 0;
}
.grid.filters {
  grid-template-columns: repeat(5, auto);
  margin-bottom: 2px !important;
}
.grid.screenings {
  grid-template-columns: repeat(11, auto);
}
.grid.screenings.cra {
  grid-template-columns: repeat(13, auto);
}
.grid.screenings > div:nth-child(24n+13),
.grid.screenings > div:nth-child(24n+14),
.grid.screenings > div:nth-child(24n+15),
.grid.screenings > div:nth-child(24n+16),
.grid.screenings > div:nth-child(24n+17),
.grid.screenings > div:nth-child(24n+24),
.grid.screenings > div:nth-child(24n+19),
.grid.screenings > div:nth-child(24n+20),
.grid.screenings > div:nth-child(24n+21),
.grid.screenings > div:nth-child(24n+22),
.grid.screenings > div:nth-child(24n+23),
.grid.screenings > div:nth-child(24n+24) {
  background-color: rgba(245, 245, 245, 0.3);
}
.pipestage {
  margin-left: 20px;
  width: 230px;
}
`, "",{"version":3,"sources":["webpack://./src/app/processing-list/processing-list.component.less"],"names":[],"mappings":"AAEA;EACI,SAAA;AADJ;AAGA;EACI,sCAAA;EACA,6BAAA;AADJ;AAGA;EACI,uCAAA;AADJ;AAGA;EACI,uCAAA;AADJ;AAGA;;;;;;;;;;;;EAYE,0CAAA;AADF;AAGA;EACI,iBAAA;EACA,YAAA;AADJ","sourcesContent":["@import (reference) url(\"../../styles.less\");\n\nh1 {\n    margin: 0;\n}\n.grid.filters {\n    grid-template-columns: repeat(5, auto);\n    margin-bottom: 2px !important;\n}\n.grid.screenings {\n    grid-template-columns: repeat(11, auto);\n}\n.grid.screenings.cra {\n    grid-template-columns: repeat(13, auto);\n}\n.grid.screenings > div:nth-child(24n+13),\n.grid.screenings > div:nth-child(24n+14),\n.grid.screenings > div:nth-child(24n+15),\n.grid.screenings > div:nth-child(24n+16),\n.grid.screenings > div:nth-child(24n+17),\n.grid.screenings > div:nth-child(24n+24),\n.grid.screenings > div:nth-child(24n+19),\n.grid.screenings > div:nth-child(24n+20),\n.grid.screenings > div:nth-child(24n+21),\n.grid.screenings > div:nth-child(24n+22),\n.grid.screenings > div:nth-child(24n+23),\n.grid.screenings > div:nth-child(24n+24) {\n  background-color: @grid-row;\n}\n.pipestage {\n    margin-left: 20px;\n    width: 230px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
